import React, { FC } from 'react';
import styled from '@emotion/styled';
import Button from '@app/components/Button';
import { SupplierValidationRecord } from '@mortee/domain/validationSystem';
import BigModal from '@app/components/BigModal';
import { css } from '@emotion/css';
import VerificationPayeeAndAccountsChanges, {
  PayeeAndAccountsWithWarnings,
} from '@mortee/routes/validationSystem/editValidtionRecord/mainTabs/verification/reviewModals/VerificationPayeeAndAccountsChanges';

interface Props {
  payeeWithAccountsWarnings: PayeeAndAccountsWithWarnings;
  supplierValidationRecord: SupplierValidationRecord;
  onConfirm: () => void;
  onClose: () => void;
}

const VerificationCheckWarningsModal: FC<Props> = ({
  onConfirm,
  onClose,
  payeeWithAccountsWarnings,
  supplierValidationRecord,
}) => {
  return (
    <Main closeFunc={onClose} title='Complete Verification' titleLineClassName={stickyTitleLine}>
      <VerificationPayeeAndAccountsChanges
        payeeWithAccountsWarnings={payeeWithAccountsWarnings}
        supplierValidationRecord={supplierValidationRecord}
      />
      <ActionsContainer>
        <Button
          id='btn-create-verification-payee-and-accounts-confirmation-modal-close'
          appearance='text'
          colorScheme='secondary'
          onClick={onClose}
        >
          CANCEL
        </Button>
        <Button
          id='btn-create-verification-payee-and-accounts-confirmation-modal-complete'
          appearance='full'
          colorScheme='secondary'
          onClick={onConfirm}
          autoFocus
        >
          COMPLETE
        </Button>
      </ActionsContainer>
    </Main>
  );
};

export default VerificationCheckWarningsModal;

const Main = styled(BigModal)`
  width: min(1050px, 90vw);
  background: #eeeeee;

  max-height: 95vh;
  overflow: auto;

  // Horizontal padding will be applied by the content
  padding: 0;

  --side-padding: 24px;
  --card-padding: 16px 24px;
`;

const stickyTitleLine = css`
  background: white;
  position: sticky;
  top: 0;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  // To allow the buttons drop shadow to fully show
  padding: var(--card-padding);

  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;
